import React, { Fragment, useEffect, useContext } from "react";
import WorkOrderDetails from "./wo_details/WorkOrderDetails";
import { observer } from "mobx-react-lite";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import UserAuthStore from "../../../app/stores/userauthStore";
import { ButtonContent, Placeholder, Search, Grid, Icon} from "semantic-ui-react";
import oneOrderStore from "../../../app/stores/oneOrderStore";
import AllGrid from "./wo_grid/AllGrid";
import AllDetails from "./wo_details/AllDetails";
import WorkOrderGrid from "./wo_grid/WorkOrderGrid";
import InvoicedDetails from "./wo_details/InvoicedDetails";
import InvoicedGrid from "./wo_grid/InvoicedGrid";
interface IProps {}

function getvalue(){
  var value = (document.getElementById("input") as HTMLInputElement).value;
  return value
}


const WorkOrderDashboard: React.FC<IProps> = props => {
  const workOrderStore = useContext(oneOrderStore);
  const userAuthStore = useContext(UserAuthStore);

  let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!)
  let IsLoggedIn = sessionStorage.getItem("isLoggedIn")
  let CurrentModule = sessionStorage.getItem("module")

  useEffect(() => {
    userAuthStore.HydrateAuthState();
   }, [userAuthStore]);

  function searchJobs(){
      
      workOrderStore.loadWorkOrders(CurrentModule!,sessionObj.Username,sessionObj.Client.Id,getvalue());
  

  };
  if (workOrderStore.loadinginitial){
    return <LoadingComponent content={"Loading: " + CurrentModule} inverted={true} />;

  }

  

  return(
    <Fragment>
      <br></br>
          <Grid>
          <Search 
          icon= "none"
          id="input"
          open={false}
          onBlur={searchJobs}
          type='text'
          size="mini"
          display="inline"
          placeholder="Search invoiced jobs"
          />
          <Icon name="search"  size="large" color="grey"/>
        </Grid>
          
          
          <br></br>
      <InvoicedGrid workorders={workOrderStore.workorders} />
    <InvoicedDetails />
</Fragment>)
;}

export default observer(WorkOrderDashboard);
